<input type="text" [ngModel]="inputString" (change)="onSelectChange($event)" />

<!--div class="trend_input">


    <select title="{{'Input'|translate}}" [ngModel]="inputString" (change)="onSelectChange($event.target.value)">
        <option *ngFor="let input of Inputs" value="{{input.Id}}" [selected]="inputString == input.Id">
            {{input.Name|translate}} {{(input.Id!= "-") ? "("+input.Id+")" : ""}}
        </option>
    </select>
    <input *ngIf="getMaxInputNumber() > 0" type="number" [min]="0" [max]="getMaxInputNumber()" [ngModel]="inputNumber"
           (change)="onInputChange($event.target.value)" />
</div-->
